<template>
    <div class="change-main">
        <div class="change-container">
            <div class="title">修改密码</div>
            <div class="main">
                <el-steps :active="active" align-center finish-status="success">
                    <el-step title="修改密码"></el-step>
                    <el-step title="成功"></el-step>
                </el-steps>
                <!-- 修改密码页面 -->
                <el-form ref="ChangeForm" class="change-form" hide-required-asterisk status-icon aria-autocomplete="no" :model="ChangeForm" :rules="ChangeRules" label-width="1rem" id="step2">
                  <el-form-item prop="oldPassword" label="原密码">
                    <el-input style="width: 86%;" name="oldPassword" type="password" v-model="ChangeForm.oldPassword" autoComplete="on" placeholder="请输入原密码"></el-input>
                  </el-form-item>
                    <el-form-item prop="password" label="新密码">
                        <el-input style="width: 86%;" name="password" type="password" v-model="ChangeForm.password" autoComplete="on" placeholder="请输入新密码"></el-input>
                        <i id="keywordtitle" class="el-icon-warning" style="font-size: xx-small;color: gainsboro;width: 85%">密码须含有小写字母、大写字母、数字、特殊符号中的任意三种</i>
                    </el-form-item>
                    <el-form-item prop="again" label="确认密码">
                        <el-input style="width: 86%;" name="again" type="password" v-model="ChangeForm.again" autoComplete="on" placeholder="再次输入密码"></el-input>
                    </el-form-item>

                    <el-form-item label="">
                        <el-button type="primary" style="width: 86%;" @click="submitForm('ChangeForm')">下一步</el-button>
                    </el-form-item>
                </el-form>
                <!-- 结果页面 -->
                <div class="change-form" id="step3">
                    <div class="outer">
                        <div id="loading">
                            <div>
                                <i class="el-icon-loading" style="font-size: 0.4rem;"></i>
                                <p>请等待</p>
                            </div>
                        </div>
                        <div id="success" style="display: none;">
                            <div>
                                <i class="el-icon-check" style="font-size: 0.4rem;"></i>
                                <p>密码修改成功</p>
                            </div>
                        </div>
                        <el-button type="success" :disabled="disable" @click="Jump()">去登陆</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {jump, setTokenKey, checkPassword, ValidatePassWord} from '../../untils/auth'
import $ from 'jquery'
import CryptoJS from "@/untils/CryptoJS";
export default {
    name: 'ResetPass',
    data() {
        const validateOldPass = (rlue, value, callback) => {
          if (!value) {
            callback(new Error('请输入旧密码'))
          } else {
            callback()
          }
        }
        const validatePassword = (rule, value, callback) => {
            if(!value){
                callback(new Error('密码不能为空'))
            }else if(!ValidatePassWord(value)){
              callback(new Error("密码格式有误!"))
            }else{
                callback();
            }
        }
        const validateAgain = (rlue, value, callback) => {
            if (!value) {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.ChangeForm.password) {
                callback(new Error('两次输入密码不一致'))
            } else {
                callback()
            }
        }
        return {
            VUserId: '',
            userName: '',
            ChangeForm: {
                oldPassword: '',
                password: '',
                again: ''
            },
            ChangeRules: {
                oldPassword: [{ required: true, trigger: 'blur', validator: validateOldPass }],
                password: [{ required: true, trigger: 'blur', validator: validatePassword }],
                again: [{ required: true, trigger: 'blur', validator: validateAgain }],
            },
            active: 1,
            disable: true,

        }
    },
    created() {
        this.VUserId = this.$route.query.VUserId
        this.userName = this.$route.query.userName
    },
    methods: {
        jump,
        Jump () {
            setTokenKey('url',this.$route.path);
            this.jump('/login')
        },


        submitForm (formName) {
            let _this = this
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ChangeForm.oldPassword = CryptoJS.encrypt(this.ChangeForm.oldPassword)
                    this.ChangeForm.password = CryptoJS.encrypt(this.ChangeForm.password)
                     console.log(this.ChangeForm.oldPassword)
                    var obj = {
                      oldPassword: this.ChangeForm.oldPassword,
                      password: this.ChangeForm.password,
                      VUserId: this.VUserId,
                    }
                    this.axios.post(window.IPConfig.IP + '/LoginController/resetPasswordByUserId.do',obj).then(response => {
                        if(response.status == 200){
                            if(response.data.status == 200){
                                this.ChangeForm.password = CryptoJS.decrypt(this.ChangeForm.password)
                                this.ChangeForm.oldPassword = CryptoJS.decrypt(this.ChangeForm.oldPassword)
                                _this.active = 2;
                                $('#step2').hide();
                                $('#step3').show();
                                setTimeout(function () {
                                    $('#success').show();
                                    $('#loading').hide();
                                    _this.active = 3;
                                    _this.disable = false;
                                }, 3000)
                            }else{
                              this.ChangeForm.oldPassword="";
                              this.ChangeForm.password="";
                              this.ChangeForm.again="";
                              this.$message.error(response.data.msg);
                            }
                        }
                    })

                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style>
    .change-main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .change-container {
        width: 90%;
        height: 80%;
        background: #fff;
        padding: 0px 0.5rem;
    }
    .change-container .title {
        font-size: 0.2rem;
        border-bottom: 0.01rem solid #dcdfe6;
        padding: 0.3rem 0;
    }
    .change-container .main {
        width: 60%;
        margin: 0.3rem auto 0;
    }
    .change-container .main .change-form {
        width: 65%;
        margin: 0.5rem auto;
    }
    .change-container .main #step3 {
        display: none;
        height: 1.6766rem;
    }
    .change-container .main #step3 .outer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .change-container .main #step3 .outer #loading div, .change-container .main #step3 .outer #success div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .change-container .main #step3 .outer i {
        margin: 0.1rem auto 0.2rem;
    }
    .change-container .main #step3 .outer .el-button {
        margin: 0.41rem auto 0;
        width: 86%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login/resetPass.vue